import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { Params } from "@/types";

const endpoint = {
  bonus: "/bonus",
};

export const fetchBonus = createAsyncThunk(
  "bonus/fetchBonus",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.bonus, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const createBonus = createAsyncThunk(
  "bonus/createBonus",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.post(endpoint.bonus, data);
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const updateBonus = createAsyncThunk(
  "bonus/updateBonus",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.put(
        `${endpoint.bonus}/${data.slug}`,
        data,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const deleteBonus = createAsyncThunk(
  "bonus/deleteBonus",
  async (slug: string, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(`${endpoint.bonus}/${slug}`);
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);
